// tslint:disable:no-string-literal
import { Button, Card, Col, Divider, Modal, notification, Row, Table } from 'antd';
import * as React from 'react';

import LanguagesQuery from '../../components/Query/Languages';
import LanguageDetail from './LanguageDetail';
import { Title } from '../../components/Layout/components';

interface ILanguagesTableState {
  language?: GQL.ILanguage;
}

interface ILanguagesTableProps { }

export default class LanguagesTable extends React.Component<ILanguagesTableProps, ILanguagesTableState> {

  constructor(props: ILanguagesTableProps) {
    super(props);
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <LanguagesQuery>
            {({ languages, deleteLanguage, createLanguage }: any) => {
              return this.renderData(
                languages.languages,
                createLanguage,
                deleteLanguage,
                languages.refetch
              );
            }}
          </LanguagesQuery>
        </Col>
      </Row>
    );
  }

  private renderData(languages: any, createLanguage: Function, deleteLanguage: Function, refetch: Function) {
    if (languages) {
      return (
        <div>
          <Title>Languages</Title>
          <Divider />
          <Button onClick={() => this.newLanguage()}>Create new language</Button>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={languages}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column title="Value" dataIndex="value" key="value" />
            <Table.Column
              width={300}
              title="Actions"
              dataIndex="actions"
              key="actions"
              render={(u: any, row: any) => this.renderActions(u, row, deleteLanguage, refetch)}
            />
          </Table>
          {this.state &&
            this.state.language && (
              <LanguageDetail
                language={this.state.language}
                onSave={a => this.upsert(a, createLanguage, refetch)}
                onCancel={() => this.setCurrentLanguage(undefined)}
              />
            )}
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading languages ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, language: GQL.ILanguage, deleteLanguage: Function, refetch: Function) {
    return (
      <div>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(language, deleteLanguage, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private newLanguage() {
    this.setCurrentLanguage({
      value: ''
    });
  }

  private setCurrentLanguage(language: any) {
    this.setState({ language });
  }

  private delete(language: GQL.ILanguage, deleteLanguage: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${language.value}?`,
      content: (
        <span>
          Are you sure you want to delete language <strong>{language.value}</strong>
        </span>
      ),
      onOk: () => {
        return deleteLanguage({
          variables: {
            id: language.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(language: GQL.ILanguage, createLanguage: Function, refetch: Function) {
    if (language != undefined) {
      const variables = {
        id: language.id,
        language: { value: language.value }
      };

      createLanguage({ variables })
        .then(() => this.setCurrentLanguage(null))
        .then(() => refetch())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Language "${variables.language.value}" has been created.`
          })
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Languages/LanguagesTable.tsx